
import { defineComponent, reactive } from 'vue'

// components
import Modal from '@/common/components/UI/Modal/index.vue'
import TheInput from '@/common/components/UI/TheInput/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

// validation
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

// realisations
import { FTL } from '@/core/realisations/FTL.realisation'

// types
import { ChangeActNumberPayloadT } from '@/core/types/ftl.types'

// composable
import useNotifications from '@/common/composable/useNotifications'

export default defineComponent({
    components: {
        Modal,
        TheInput,
        TheButton,
    },
    emits: ['toggle'],
    setup(_, { emit }) {
        const notifications = useNotifications()

        const state = reactive({
            is_loading: false,
        })

        const payload = reactive({
            actNumber: null as string | null,
            ftlOrderIds: [null] as (number | null)[],
        })

        const state_form$ = useVuelidate(
            {
                actNumber: { required },
            },
            payload
        )

        const emitToggle = () => emit('toggle')

        const changeActNumber = async () => {
            state_form$.value.$touch()
            if (state_form$.value.$invalid || !payload.ftlOrderIds.every((value) => value)) return

            try {
                state.is_loading = true

                const params = { ...payload }

                await FTL.changeActNumber(params as ChangeActNumberPayloadT)

                notifications.notify({ title: 'Номер АВР успешно изменен!', type: 'success' })
                emit('toggle')
            } catch (error) {
                console.error(error)
                notifications.notifyError({
                    error,
                    title: 'При изменении номера АВр произошла ошибка',
                })
            } finally {
                state.is_loading = false
            }
        }

        const addOrder = () => payload.ftlOrderIds.push(null)
        const deleteOrder = (idx: number) => {
            if (payload.ftlOrderIds.length < 2) return

            payload.ftlOrderIds.splice(idx, 1)
        }

        return {
            state,
            payload,
            //
            state_form$,
            //
            emitToggle,
            changeActNumber,
            addOrder,
            deleteOrder,
        }
    },
})
